import React, { Fragment, Component } from "react";
import { reduxForm } from "redux-form";
import validate from "./validate";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import { connect } from "react-redux";

class WizardFormReviewPage extends Component {
  render() {
    const { handleSubmit, pristine, previousPage, submitting } = this.props;

    const {
      aasisId,
      processorTaxidermyId,
      utme,
      utmn,
      county,
      cwdCode,
      customerID,
      gameCheckNumber,
      firstName,
      lastName,
      address,
      city,
      zipCode,
      phoneNumber,
      killDate,
      species,
      killType,
      sex,
      age,
      earNotch,
      donated,
      comment,
      googleCoordinates
    } = this.props.form.wizard.values;

    return (
      <Fragment>
        <Typography variant="title" color="inherit">
          Review
        </Typography>
        <hr />

        <List component="nav">
          <ListItem>
            <ListItemText
              primary="Aasis ID"
              secondary={aasisId ? aasisId : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Processor OR Taxidermy ID"
              secondary={
                processorTaxidermyId ? processorTaxidermyId : undefined
              }
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="UTME"
              secondary={utme ? utme : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="UTMN"
              secondary={utmn ? utmn : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Google Maps"
              secondary={googleCoordinates ? googleCoordinates : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="County"
              secondary={county ? county : undefined}
            />
          </ListItem>
          <Divider />

          <ListItem>
            <ListItemText
              primary="CWD Code"
              secondary={cwdCode ? cwdCode : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Customer ID"
              secondary={customerID ? customerID : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="gameCheckNumer"
              secondary={gameCheckNumber ? gameCheckNumber : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="First Name"
              secondary={firstName ? firstName : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Last Name"
              secondary={lastName ? lastName : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Address"
              secondary={address ? address : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="City" secondary={city ? city : undefined} />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Zip Code"
              secondary={zipCode ? zipCode : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Phone Number"
              secondary={phoneNumber ? phoneNumber : undefined}
            />
          </ListItem>
          <Divider />

          <ListItem>
            <ListItemText
              primary="Date of Kill"
              secondary={killDate ? killDate : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Species"
              secondary={species ? species : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Type of Kill"
              secondary={killType ? killType : undefined}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Sex" secondary={sex ? sex : undefined} />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText primary="Age" secondary={age ? age : undefined} />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Ear Notch"
              secondary={earNotch === true ? "True" : "False"}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Donated"
              secondary={donated === true ? "True" : "False"}
            />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemText
              primary="Comments"
              secondary={comment ? comment : undefined}
            />
          </ListItem>
          <Divider />
        </List>

        <form onSubmit={handleSubmit}>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={previousPage}
            >
              Previous
            </button>

            <button
              className="btn btn-success"
              type="submit"
              disabled={pristine || submitting}
            >
              Submit
            </button>
          </div>
        </form>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  form: state.form
});

const SMARTCOMPONENT = connect(mapStateToProps)(WizardFormReviewPage);

export default reduxForm({
  form: "wizard", //Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  validate
})(SMARTCOMPONENT);



// WEBPACK FOOTER //
// ./src/components/wizardSection/WizardFormReviewPage.jsx